import { SortConfig } from './types';

export const AhfcDomain = '@ahfc.us';
export const TenantHttpHeaderKey = 'x-unity-tenant';

export const DefaultSortBy = 'name';
export const DefaultGlobalSort: SortConfig = {
  field: DefaultSortBy,
  dir: 'asc',
};
export const DefaultPageSize = 50;
